import get from "lodash/get"
import styled from "styled-components"
import tw from "twin.macro"
import RichText from "./RichText"
import LinkWrapper from "./LinkWrapper"
import { urlHelper } from "../util"
import cyanBgImage from "../img/cta-bg-cyan.svg"
import AnniversaryLogo from "./AnniversaryLogo"

const StyledCallToAction = styled.div`
  ${(props) => (props.backgroundImage ? tw`bg-cover bg-center` : ``)}
  ${(props) =>
    props.backgroundImage &&
    `
    &.lazyloaded {
      background-image: url('${props.backgroundImage}?w=1168&h=425&fm=jpg&q=85&auto=format');
      @media
        only screen and (-webkit-min-device-pixel-ratio: 2),
        only screen and (min-resolution: 144dpi) {
        background-image: url('${props.backgroundImage}?w=1168&h=425&fm=jpg&q=50&dpr=2&auto=format');
      }
    }
  `}
`

const StyledLink = styled(LinkWrapper)`
  ${tw`hover:underline focus:outline-none focus:ring mb-6`}
  ${(props) => !props.contrast && tw`text-action-link hover:text-action`}
  ${(props) => props.contrast && tw`text-white hover:text-gray-200`}
  transition: color 150ms ease-in-out;
`

const TextColumn = styled.div`
  ${(props) => (props.contrastText ? tw`text-white` : ``)}

  a:not([class]) {
    ${tw`underline hover:underline`}
    ${(props) =>
      props.contrastText
        ? tw`text-white hover:text-gray-400`
        : tw`hover:text-gray-600`}
  }
`

const HomeCallToAction = ({ contentItem, currentLanguage, textSize }) => {
  const backgroundImage = get(contentItem, "elements.background_image.value[0]")
  const backgroundImageUrl = get(
    backgroundImage,
    "elements.image__asset.value[0].url"
  )
  const buttonPosition =
    get(contentItem, "elements.button_position.value[0].codename") || "right"
  const contrastText =
    get(contentItem, "elements.contrast_text.value[0].codename") === "yes"
      ? "true"
      : "false"
  const heading = get(contentItem, "elements.heading.value")
  const text = get(contentItem, "elements.text.value")
  const textLinks = get(contentItem, "elements.text.links")
  const ctaText = get(contentItem, "elements.button_text.value")
  const linkTo = get(contentItem, "elements.link_to.value[0]")
  const theme = contrastText ? "dark" : "default"

  return (
    <StyledCallToAction
      className={`lazyload p-6 md:p-12 flex flex-col flex-wrap justify-center items-center ${
        buttonPosition === `right` ? `sm:flex-nowrap ` : ``
      } rounded-lg shadow-md border border-gray-300 ${
        theme === "dark" ? `bg-gray-800` : `bg-white`
      } ${!backgroundImage ? `bg-right-bottom bg-no-repeat` : ``}  ${
        textSize === "xl" ? `text-lg` : ``
      }`}
      style={
        !backgroundImage
          ? {
              backgroundImage: `url('${cyanBgImage}')`,
              backgroundSize: `627px 90px`,
            }
          : {}
      }
      backgroundImage={backgroundImageUrl}
      theme={contrastText ? "dark" : "default"}
      data-analytics-region="Call to Action"
    >
      <TextColumn
        className={`${
          buttonPosition === `right` ? `sm:pr-6 ` : ``
        } w-full md:max-w-xl text-center`}
        contrastText={contrastText}
      >
        {heading && (
          <h2
            className={`text-2xl mb-2 font-bold leading-tight ${
              contrastText ? `text-white` : `text-gray-900`
            }`}
          >
            {heading}
          </h2>
        )}
        <div
          className={`leading-snug space-y-2 md:text-xl ${
            heading ? `mt-1` : ``
          }`}
        >
          <RichText
            content={text}
            links={textLinks}
            currentLanguage={currentLanguage}
          />
        </div>
      </TextColumn>

      <div
        className={`mt-4 mb-8 whitespace-nowrap ${
          buttonPosition === `right` ? `sm:mt-0 shrink-0` : ``
        }`}
      >
        {ctaText && (
          <StyledLink
            to={linkTo && urlHelper(linkTo)}
            contrast={contrastText}
            data-analytics-title={get(
              contentItem,
              "elements.link_to.value[0].system.name"
            )}
          >
            {ctaText}
            <i className="icon-chevron-right w-4"></i>
          </StyledLink>
        )}
      </div>

      <div className={`mx-auto md:mx-0 md:flex`}>
        <AnniversaryLogo
          currentLanguage={currentLanguage}
          className={`mx-auto md:ml-auto md:mr-0`}
        />
      </div>
    </StyledCallToAction>
  )
}

export default HomeCallToAction
